import { render, staticRenderFns } from "./chinamapMobile.vue?vue&type=template&id=2c93e512&scoped=true&"
import script from "./chinamapMobile.vue?vue&type=script&lang=js&"
export * from "./chinamapMobile.vue?vue&type=script&lang=js&"
import style0 from "./chinamapMobile.vue?vue&type=style&index=0&id=2c93e512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93e512",
  null
  
)

export default component.exports